/**
 * Calculates what percentage off b is from a to the nearest integer
 * if either a or b is 0 - returns 0
 * will return 0 is b is greater than a
 *
 * example:
 *   percentOff(100, 85) -> 15
 *   percentOff(85, 100) -> 0
 *   percentOff(100, 0) -> 0
 *   percentOff(0, 100) -> 0
 *   percentOff('','') -> 0
 *
 * @param {number} a - the total number
 * @param {number} b - the discounted number
 * @returns {number} - the percent off b is from a
 */
function percentOff(a, b) {
  if (!Number.isFinite(a) || !Number.isFinite(b)) return 0;
  const roundedA = Math.round(a);
  const roundedB = Math.round(b);

  if (
    roundedA === roundedB ||
    [roundedA, roundedB].includes(0) ||
    roundedB > roundedA
  )
    return 0;

  return 100 - Math.round(100 * (b / a));
}

export default percentOff;
